import { useState } from "react";
import { Box, Grid } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import IntelligenceTimeFilter from "../../../../components/IntelligenceTimeFilter";
import TrafficLogsGraph from "./TrafficLogsGraph";
import ProtocolAnalyzer from "./ProtocolAnalyzer";
import TrafficLogsTable from "./TrafficLogsTable";
import PairDetailDialog from "./PairDetailDialog";

dayjs.extend(utc);
dayjs.extend(timezone);

// "Traffic Logs" tab — the security-log ("tiresia") view of this asset's
// traffic, restored from the removed "Search by IP" page: protocol
// classification with threat-keyword coloring, and a source↔destination pair
// table whose "Details" button opens the full port-to-port drill-down
// (PairDetailDialog). Deliberately separate from "Connections", which is the
// conduit/asset-inventory view and has no security-log drill-down.
const TrafficLogsPanel = ({ ip, multiSecurityView = false }) => {
  const tz = sessionStorage.getItem("timezone") || "Etc/GMT";
  const [dateFilter, setDateFilter] = useState({
    dateFrom: dayjs().tz(tz).subtract(1, "day"),
    dateTo: dayjs().tz(tz),
  });
  const [selectedPair, setSelectedPair] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleChangeDate = (newDateFilter) => {
    setDateFilter({
      dateFrom: dayjs(newDateFilter.dateFrom).tz(tz),
      dateTo: dayjs(newDateFilter.dateTo).tz(tz),
    });
  };

  return (
    <Box sx={{ p: "1rem" }}>
      <IntelligenceTimeFilter
        onDateChange={handleChangeDate}
        initialDateFrom={dateFilter.dateFrom}
        initialDateTo={dateFilter.dateTo}
      />

      {(loading || graphData.length > 0) && (
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid size={7} sx={{ height: 440 }}>
            <TrafficLogsGraph ipAddress={ip} graphData={graphData} charged={!loading} />
          </Grid>
          <Grid size={5} sx={{ height: 440 }}>
            <ProtocolAnalyzer ip={ip} multiSecurityView={multiSecurityView} />
          </Grid>
        </Grid>
      )}

      <Box sx={{ mt: 2, height: "55vh" }}>
        <TrafficLogsTable
          ipAddress={ip}
          dateFilter={dateFilter}
          multiSecurityView={multiSecurityView}
          onOpenPair={setSelectedPair}
          loading={loading}
          setLoading={setLoading}
          setGraphData={setGraphData}
        />
      </Box>

      <PairDetailDialog
        open={Boolean(selectedPair)}
        pair={selectedPair}
        dateFilter={dateFilter}
        multiSecurityView={multiSecurityView}
        onClose={() => setSelectedPair(null)}
      />
    </Box>
  );
};

export default TrafficLogsPanel;
